var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-image__container", class: _vm.className },
    [
      _c("div", { staticClass: "bg-image", class: _vm.className + "-img" }, [
        _c("img", { attrs: { src: _vm.image, alt: "Background Image" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg-image__txt-box" }, [
        _c("div", {
          staticClass: "bg-image__txt",
          domProps: { innerHTML: _vm._s(_vm.text) }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }